import Sentry from "./sentry";

export default Sentry;
